module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[31]30.90fe849.woff2";